import { render, staticRenderFns } from "./card2.vue?vue&type=template&id=0d4f4340&"
import script from "./card2.vue?vue&type=script&lang=js&"
export * from "./card2.vue?vue&type=script&lang=js&"
import style0 from "./card2.vue?vue&type=style&index=0&id=0d4f4340&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports